import { render, staticRenderFns } from "./ModalTransfer.vue?vue&type=template&id=5d85e177&scoped=true"
import script from "./ModalTransfer.vue?vue&type=script&lang=js"
export * from "./ModalTransfer.vue?vue&type=script&lang=js"
import style0 from "./ModalTransfer.vue?vue&type=style&index=0&id=5d85e177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85e177",
  null
  
)

export default component.exports